import type { GDoubleRowStoryblok } from '~storyblok-types/GDoubleRowStoryblok';
import type { GSingleColumnStoryblok } from '~storyblok-types/GSingleColumnStoryblok';
import type { GTripleRowStoryblok } from '~storyblok-types/GTripleRowStoryblok';

type DoubleRowStyleFields = Pick<
    GDoubleRowStoryblok,
    | 'gridChangeWeighting'
    | 'margin'
    | 'marginDesktop'
    | 'padding'
    | 'paddingDesktop'
    | 'gap'
    | 'gapDesktop'
    | 'theme'
    | 'backgroundPosition'
    | 'verticalAlign'
>;

type SingleColumnStyleFields = Pick<
    GSingleColumnStoryblok,
    'margin' | 'marginDesktop' | 'padding' | 'paddingDesktop' | 'gap' | 'gapDesktop' | 'theme' | 'backgroundPosition'
>;

type TripleRowStyleFields = Pick<GTripleRowStoryblok, 'margin' | 'padding' | 'gap' | 'theme'>;

type MergeStyleFields<A, B, C> = {
    [K in keyof A | keyof B | keyof C]?:
        (K extends keyof A ? A[K] : never) | (K extends keyof B ? B[K] : never) | (K extends keyof C ? C[K] : never);
};

type BlokWithStyleClasses = MergeStyleFields<DoubleRowStyleFields, SingleColumnStyleFields, TripleRowStyleFields>;

function styleClass(prefix: string, value: string | undefined): string | undefined {
    if (!value) return undefined;
    return `${prefix}${value}`;
}

export default function blokStyleClasses(blok: BlokWithStyleClasses) {
    return {
        customGridWeighting: styleClass('--grid-', blok.gridChangeWeighting),
        customMargin: styleClass('--margin-', blok.margin),
        customMarginDesktop: styleClass('--margin-desktop-', blok.marginDesktop),
        customPadding: styleClass('--padding-', blok.padding),
        customPaddingDesktop: styleClass('--padding-desktop-', blok.paddingDesktop),
        customGap: styleClass('--gap-', blok.gap),
        customGapDesktop: styleClass('--gap-desktop-', blok.gapDesktop),
        customTheme: styleClass('--bg-color-', blok.theme),
        backgroundPosition: styleClass('--bg-position-', blok.backgroundPosition),
        verticalAlign: styleClass('--align-', blok.verticalAlign)
    };
}
